angular.module('impactx.catalog').directive('ixCatalogRuleItemInformation', function ()
{
    return {
        scope: {
            yesLabel: "@",
            noLabel: "@",
            catalogRule: "="
        },
        restrict: 'E',
        templateUrl: 'modules/catalog/templates/catalog-rule-item-information.html',
        transclude: true
    };
});